import { render, staticRenderFns } from "./ClothesSizes.vue?vue&type=template&id=62313c58&"
import script from "./ClothesSizes.vue?vue&type=script&lang=js&"
export * from "./ClothesSizes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports